import React from 'react'
import { TriangleAlert } from 'lucide-react'
import Tooltip from './Tooltip'

const WarningIcon = ({ tooltip }: { tooltip?: string }) => {
  return tooltip ? (
    <Tooltip label={tooltip}>
      <TriangleAlert />
    </Tooltip>
  ) : (
    <TriangleAlert />
  )
}

export default WarningIcon
